export default __webpack_public_path__ + "static/media/adi-kaidar.34adf56c.png";